import type { ChartCard, SavedPopulation } from "@/types";

interface AnalysisSubtitleCard {
  content?: Record<string, unknown> | null;
}

export function analysisCardSubtitle(
  card: AnalysisSubtitleCard,
  availableCards: ChartCard[],
  savedPopulations: SavedPopulation[],
): string {
  const content = card.content || {};
  const nameOf = (questionId: unknown) =>
    availableCards.find((c) => (c.questions || []).some((q) => q.id === questionId))?.name || "";
  const populationName = (token: unknown) => savedPopulations.find((s) => s.token === token)?.name || "";
  const unique = (names: string[]) => [...new Set(names.filter(Boolean))];

  switch (content.sub_type) {
    case "crosstab": {
      const columns = (content.columns || []) as { type?: string; question_id?: number; search_group_token?: string }[];
      return unique(
        columns.map((col) => (col.type === "population" ? populationName(col.search_group_token) : nameOf(col.question_id))),
      ).join(", ");
    }
    case "importance_performance":
    case "key_drivers": {
      const ids = (content.matrix_question_ids || []) as number[];
      const matrix = ids.length
        ? availableCards.find((c) => c.type === "q_matrix" && (c.questions || []).some((q) => ids.includes(q.id)))
        : null;
      return unique([nameOf(content.global_question_id), matrix?.name || ""]).join(" × ");
    }
    case "sankey":
      return unique([nameOf(content.source_question_id), nameOf(content.target_question_id)]).join(" → ");
    case "funnel": {
      const stages = (content.stages || []) as { label?: string }[];
      return unique(stages.map((stage) => stage.label || "")).join(" → ");
    }
    case "kpi":
    case "kpi_trend":
      return nameOf((content.metric as { question_id?: number } | undefined)?.question_id);
    default:
      return nameOf(content.question_id);
  }
}
